import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//import { initReactI18next } from "react-i18next/hooks";
import moment from 'moment';
import Cookies from 'js-cookie';
import { isLocalhost } from 'serviceWorker';

import 'moment/locale/ro.js';
import 'moment/locale/de.js';

// var options = {
//     weekday: "long", year: "numeric", month: "short",
//     day: "numeric", hour: "2-digit", minute: "2-digit"
// };

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      fallbackLng: 'en',

      // have a common namespace used around the full app
      ns: ['translations'],
      defaultNS: 'translations',

      debug: true,

      detection: {
        order: ['cookie', 'localStorage'],
        lookupCookie: 'language'
      },

      interpolation: {
        escapeValue: false, // not needed for react!!
        format: function (value, format, lng) {
          if (format === 'uppercase') return value.toUpperCase();
          if (format === 'intlDate') {
            if (value && moment(value).isValid()) {
              return moment(value).format('L');
            }
            return '';
          }

          if (format === 'intlLongDate') {
            if (value && moment(value).isValid()) {
              return moment(value).format('LLLL');
            }
            return '';
          }

          if (format === 'intlDateTime') {
            if (value && moment(value).isValid()) {
              return moment(value).format('L') + ', ' + moment(value).format('LT');
            }
            return '';
          }

          if (format === 'intlTimeFromX') {
            if (value && moment(value.start).isValid()) {
              let startDate = moment(value.start);
              let endDate = moment(value.end);
              return moment(endDate).from(startDate, true);
            }
            return '';
          }

          if (format === 'intlHoursFromX') {
            if (value && moment(value.start).isValid()) {
              let startDate = moment(value.start);
              let endDate = moment(value.end);
              let span = moment.duration(endDate - startDate);
              return `${parseInt(span.asHours(), 10)}h ${parseInt(span.asMinutes() % 60, 10)}m`;
            }
            return '';
          }

          if (format === 'intlNumber') return new Intl.NumberFormat(lng).format(value);
          if (format === 'intlDecimal') return new Intl.NumberFormat(lng, { minimumFractionDigits: 2 }).format(value);
          if (format === 'intlDecimal2')
            return new Intl.NumberFormat(lng, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
          if (format === 'intlDecimal4') {
            return new Intl.NumberFormat(lng, { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(value);
          }
          if (format === 'cvsChPercentNumber') {
            return new Intl.NumberFormat(lng, { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(value);
          }

          //dateformat
          if (value && value.format) {
            if (value.value && moment(value).isValid()) {
              return moment(value.value).format(value.format);
            }
            return '';
          }

          return value;
        }
      },

      react: {
        wait: true,
        usePureComponent: true,
        useSuspense: false
      },

      backend: {
        loadPath: '/static/locales/{{lng}}/{{ns}}.json'
      }
    },
    () => {
      let currentLang = i18n.language;
      if (!currentLang || currentLang.startsWith('ro')) {
        i18n.changeLanguage('ro-RO');
      } else if (!currentLang || currentLang.startsWith('en')) {
        i18n.changeLanguage('en-GB');
      } else if (!currentLang || currentLang.startsWith('fr')) {
        i18n.changeLanguage('fr-FR');
      }
    }
  );

const getDomain = () => {
  const hostname = window.location.hostname.split('.');
  hostname.reverse();
  return !hostname[1] ? hostname[0] : `${hostname[1]}.${hostname[0]}`;
};

i18n.on('languageChanged', function (lng) {
  const cookiesOptions = {
    path: '/'
  };
  if (isLocalhost === false) {
    cookiesOptions.sameSite = 'None';
    cookiesOptions.secure = true;
    cookiesOptions.domain = getDomain();
  }
  Cookies.set('language', lng, cookiesOptions);
  moment.locale(lng);
});

export default i18n;
